import React from "react"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas }     from "@fortawesome/free-solid-svg-icons"
library.add(fas)
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ProductPicker from "@react/shared/ui/ProductPicker"

// Toolbar filter for the Ouvrages index: restrict the list to ouvrages that
// contain a given product. Navigates with ?product_id=… (resetting page) while
// preserving the current search / scope / sort params from the URL.
const ProductFilter = ({ selected, placeholder, clearLabel }) => {
  const go = productId => {
    const url = new URL(window.location)
    if (productId) url.searchParams.set("product_id", productId)
    else           url.searchParams.delete("product_id")
    url.searchParams.delete("page")
    window.location.assign(url.pathname + url.search)
  }

  if (selected && selected.id) {
    return (
      <div className="flex items-center gap-1.5 h-9 px-2.5 rounded-md border border-brand-200 bg-brand-50 text-sm text-brand-800">
        <FontAwesomeIcon icon="box" className="text-brand-500 shrink-0" />
        <span className="flex-1 truncate" title={selected.name}>{selected.name}</span>
        <button type="button" onClick={() => go(null)} title={clearLabel} className="text-brand-600 hover:text-brand-900 shrink-0">
          <FontAwesomeIcon icon="xmark" />
        </button>
      </div>
    )
  }

  return <ProductPicker placeholder={placeholder} onSelect={product => go(product.id)} />
}

export default ProductFilter
